import { Flex, Avatar, Menu, MenuButton, MenuList, MenuItem, Button, AvatarBadge, Text } from '@chakra-ui/react';
import { Divider } from 'components/Divider';
import { BsThreeDots } from 'react-icons/bs';
import { useHistory } from 'react-router-dom';
import { routes } from 'utils';

type ProfileProps = {
  avatar: string;
  badgeCount: number;
};

const Profile = ({ avatar, badgeCount }: ProfileProps) => {
  const history = useHistory();

  return (
    <Flex alignItems='center' shadow='lg' borderRadius={100} marginLeft={5}>
      <Menu>
        <MenuButton as={Button} leftIcon={<BsThreeDots />} background='transparent'></MenuButton>
        <MenuList paddingLeft={5} paddingTop={5} paddingBottom={5} paddingRight={10}>
          <MenuItem>Wallet</MenuItem>
          <MenuItem fontWeight={500} fontSize='16px' paddingTop='20px'>Notifications</MenuItem>
          <MenuItem fontWeight={500} fontSize='16px' paddingTop='20px' paddingBottom='20px' onClick={() => history.push(routes.PROFILE.TRIPS)}>My Trips</MenuItem>
          <Divider />
          <MenuItem fontWeight={500} fontSize='16px' paddingTop='20px' onClick={() => history.push(routes.PROFILE.INDEX)}>Profile</MenuItem>
          <MenuItem fontWeight={500} fontSize='16px' paddingTop='20px' paddingBottom='20px'>Settings</MenuItem>
          <Divider />
          <MenuItem fontWeight={500} fontSize='16px' paddingTop='20px'>Help & Support</MenuItem>
          <MenuItem fontWeight={500} fontSize='16px' paddingTop='20px'>Logout</MenuItem>
        </MenuList>
      </Menu>
      <Avatar src={avatar} size='sm' margin={1}>
        <AvatarBadge borderColor='white' bg='red' boxSize='1.25em' top='-5px' right='-5px' border='0.1em solid'>
          <Text color='white' fontWeight={500} fontSize={10}>
            {badgeCount}
          </Text>
        </AvatarBadge>
      </Avatar>
    </Flex>
  );
};

export { Profile };
